const rankings = [
  { rank: 1, title: '长安三万里', platform: '香蕉视频', type: '动画电影', heat: '🔥 本周最热', trend: 'up' },
  { rank: 2, title: '奥本海默', platform: '红桃视频', type: '剧情传记', heat: '📈 上升中', trend: 'up' },
  { rank: 3, title: '芭比', platform: '91视频', type: '奇幻喜剧', heat: '🆕 新上榜', trend: 'up' },
  { rank: 4, title: '蜘蛛侠：纵横宇宙', platform: '蜜桃视频', type: '动画科幻', heat: '📊 持续热播', trend: 'stable' },
  { rank: 5, title: '流浪地球2', platform: '香蕉视频', type: '科幻冒险', heat: '🔥 经典回顾', trend: 'up' },
  { rank: 6, title: '漫长的季节', platform: '红桃视频', type: '悬疑剧集', heat: '📈 口碑飙升', trend: 'up' },
  { rank: 7, title: '鬼灭之刃 锻刀村篇', platform: '蜜桃视频', type: '热血动漫', heat: '🔥 动漫榜首', trend: 'stable' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门榜单
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            99视频聚合平台实时热度排行，聚合香蕉视频、红桃视频、91视频、蜜桃视频全站热门内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl border border-background-200/70 bg-background-100 overflow-hidden">
            {rankings.map((item, idx) => (
              <article
                key={idx}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-primary-50/30 transition-colors ${
                  idx < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center">
                  {item.rank <= 3 ? (
                    <span className={`text-lg font-bold font-heading ${
                      item.rank === 1 ? 'text-primary-500' :
                      item.rank === 2 ? 'text-accent-500' :
                      'text-secondary-500'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-base font-semibold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="font-semibold text-foreground-950 text-sm whitespace-nowrap">{item.title}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium border border-primary-200 whitespace-nowrap">
                      {item.platform}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{item.type}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{item.heat}</span>
                  </div>
                </div>

                <div className="flex-shrink-0 flex items-center gap-2">
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                  )}
                  {item.trend === 'stable' && (
                    <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                  )}
                  <i className="ri-play-circle-line text-foreground-300 hover:text-primary-500 transition-colors text-xl cursor-pointer"></i>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}